import type { PropsWithChildren } from "react";

import { translate } from "app/filters/i18nFilter";
import { SearchTextBox } from "app/pages/sales-intelligence/common-components/SearchTextBox";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledSearchRow, StyledSearchContainer } from "./styles";

type Props = PropsWithChildren<{
    className?: string;
    searchText: string;
    placeholder: Translatable;
    isDisabled?: boolean;
    processSearchText?: (value: string) => string;
    onSearch: (searchText: string) => void;
    onSearchClear?: (searchText: string) => void;
}>;

const ResultsSearchRow = ({
    className,
    searchText,
    isDisabled = false,
    placeholder,
    children,
    processSearchText,
    onSearch,
    onSearchClear,
}: Props) => {
    return (
        <StyledSearchRow
            className={className}
            data-automation="search-row"
            $isDisabled={isDisabled}
        >
            <StyledSearchContainer>
                <SearchTextBox
                    searchText={searchText}
                    placeholder={translate(placeholder.key)}
                    isDisabled={isDisabled}
                    preProcessValue={processSearchText}
                    onChange={onSearch}
                    onClear={onSearchClear}
                />
            </StyledSearchContainer>
            {children}
        </StyledSearchRow>
    );
};

export default ResultsSearchRow;
